import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Card } from "../components/ui/card";
import { Package, Search } from "lucide-react";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import PageHelp from "../components/PageHelp";

const publicApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL || ""}/api`,
  withCredentials: false,
});

export default function PublicTrack() {
  const { number: paramNumber } = useParams();
  const [query, setQuery] = useState(paramNumber || "");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  const search = async (num) => {
    const n = (num || query).trim();
    if (!n) return;
    setError("");
    try {
      const { data } = await publicApi.get(`/track/${encodeURIComponent(n)}`);
      setResult(data);
    } catch {
      setResult(null);
      setError("Protocolo não encontrado");
    }
  };

  useEffect(() => {
    if (paramNumber) search(paramNumber);
  }, [paramNumber]);

  return (
    <div className="min-h-screen bg-[var(--surface-2)] p-6 flex items-center justify-center">
      <Card className="w-full max-w-lg p-6 space-y-4" data-testid="public-track-page">
        <div className="flex justify-end">
          <PageHelp pathname="/rastreio" variant="outline" />
        </div>
        <div className="text-center">
          <Package className="mx-auto text-[var(--brand)] mb-2" size={32} />
          <h1 className="font-display text-xl font-bold">Rastrear protocolo</h1>
          <p className="text-sm text-muted-foreground">Consulta pública sem login</p>
        </div>
        <div className="flex gap-2">
          <Input value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Número ou protocolo" onKeyDown={(e) => e.key === "Enter" && search()} />
          <Button onClick={() => search()}><Search size={16} /></Button>
        </div>
        {error && <p className="text-sm text-red-600">{error}</p>}
        {result && (
          <div className="space-y-2 text-sm border-t pt-4">
            <div><strong>Protocolo:</strong> {result.protocol_number || result.number}</div>
            <div><strong>Status:</strong> {result.status}</div>
            <div><strong>Cidade:</strong> {result.city}</div>
            <div><strong>Atualizado:</strong> {new Date(result.updated_at).toLocaleString()}</div>
            {(result.history || []).length > 0 && (
              <div className="mt-3">
                <div className="font-semibold mb-1">Histórico</div>
                {result.history.map((h, i) => (
                  <div key={`${h.status}-${h.at}-${i}`} className="text-xs text-muted-foreground">
                    {new Date(h.at).toLocaleString("pt-BR")} — {h.status}{h.note ? ` · ${h.note}` : ""}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </Card>
    </div>
  );
}
